import { Component, Inject } from '@angular/core';
import { Agb } from '../../models';
import { LibCoreLayoutModule } from '../core-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

export interface AgbDialogComponentData {
  agb: Agb;
  titel?: string;
}

@Component({
  selector: 'lib-agb-dialog',
  templateUrl: './agb-dialog.component.html',
  styleUrl: './agb-dialog.component.scss',
  standalone: true,
  imports: [
    LibCoreLayoutModule,
    TranslateModule,
    // material design
    MatButtonModule,
    MatDialogModule,
  ],
})
export class AgbDialogComponent {
  public agb: Agb;
  public titel: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: AgbDialogComponentData) {
    this.agb = this.data?.agb;
    this.titel = this.data?.titel;
  }
}
